import { TextField, Autocomplete } from "@mui/material";
import { useState, useEffect, type SyntheticEvent } from "react";
import { useLocation } from "react-router-dom";
import { getBranches as fetchBranches } from "../api/branches";
import type { BranchItem } from "../types/site";

type BranchSelectProps = {
  prefCode: string | string[] | null;
  customerId: number | number[] | null;
  changedValue: (value: number[]) => void;
};

export default function BranchSelect({
  prefCode,
  customerId,
  changedValue,
}: BranchSelectProps) {
  const searchParams = new URLSearchParams(useLocation().search);
  const disasterId = searchParams.get("disaster-id");

  const [branches, setBranches] = useState<BranchItem[]>([]);

  const getBranches = async () => {
    try {
      const response = await fetchBranches({
        disaster_id: disasterId,
        pref_code: prefCode,
        m_customer_id: customerId,
        order: null,
        sort: null,
        page: 1,
      });
      if (response.status === "ok") {
        const data = response.m_branches;
        setBranches(Array.isArray(data) ? data : []);
      }
    } catch (error) {
      console.error("API呼び出しエラー", error);
    }
  };

  useEffect(() => {
    getBranches();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disasterId, prefCode, customerId]);

  const handleChange = (
    _event: SyntheticEvent,
    newValues: BranchItem[]
  ) => {
    changedValue(newValues.map((newValue) => newValue.id));
  };

  return (
    <Autocomplete
      multiple
      limitTags={2}
      fullWidth
      size="small"
      options={branches}
      getOptionLabel={(branch) => branch.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={(params) => (
        <TextField {...params} placeholder="複数選択可" />
      )}
      onChange={handleChange}
    />
  );
}
